import { render, staticRenderFns } from "./commission.vue?vue&type=template&id=73f9a0eb&scoped=true"
import script from "./commission.vue?vue&type=script&lang=js"
export * from "./commission.vue?vue&type=script&lang=js"
import style0 from "./commission.vue?vue&type=style&index=0&id=73f9a0eb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f9a0eb",
  null
  
)

export default component.exports